import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import { Modal } from '@els/els-react--modal';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import CustomGroupsBar from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/CustomGroupsBar';
import { ascending, descending } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import ActiveChunk from './ActiveChunk';
import BarChartCheckboxesDialogHeader from './BarChartCheckboxesDialogHeader';
import DialogFooter from './DialogFooter';

import './BarChartCheckboxesDialog.scss';

function BarChartCheckboxesDialog(props) {
  const {
    id: dialogId,
    className,
    customGroups,
    customGroupsData,
    activeCustomGroupIndex,
    setActiveCustomGroupIndex,
    customGroupsWithByValueSorting,
    sorting,
    onAscending,
    customGroupsRadioButtonsFeatureEnabled,
  } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    const dialogsRoot = document.querySelector('.react-dialogs-root');
    if (dialogsRoot) {
      dialogsRoot.style.display = 'none';
    }
    return () => {
      if (dialogsRoot) {
        dialogsRoot.style.display = '';
      }
    };
  }, []);
  return (
    <Modal
      onClose={() => {
        dispatch(
          closeDialog({
            id: dialogId,
          })
        );
      }}
      shouldCloseOnEscape={false}
      className={cn(className, 'bar-chart-checkboxes-dialog', { 'bar-chart-checkboxes-dialog-custom-groups': customGroups })}
      id="bar-chart-checkboxes"
      shouldPreventClickOverlayToClose>
      <BarChartCheckboxesDialogHeader {...props} customGroupsRadioButtonsFeatureEnabled={customGroupsRadioButtonsFeatureEnabled} />
      {customGroupsWithByValueSorting && (
        <CustomGroupsBar
          customGroupsData={customGroupsData}
          activeCustomGroupIndex={activeCustomGroupIndex}
          setActiveCustomGroupIndex={setActiveCustomGroupIndex}
          dialogId={dialogId}
          sorting={sorting}
          onAscending={onAscending}
        />
      )}
      <ActiveChunk {...props} />
      <DialogFooter {...props} />
    </Modal>
  );
}

BarChartCheckboxesDialog.propTypes = {
  sorting: PropTypes.oneOf([ascending, descending]),
  className: PropTypes.string,
  customGroups: PropTypes.bool,
  customGroupsData: PropTypes.array,
  activeCustomGroupIndex: PropTypes.string,
  setActiveCustomGroupIndex: PropTypes.func,
  customGroupsWithByValueSorting: PropTypes.bool,
  id: PropTypes.string,
  onAscending: PropTypes.func.isRequired,
  customGroupsRadioButtonsFeatureEnabled: PropTypes.bool,
};

export default BarChartCheckboxesDialog;
